
import { createContext, useContext, useState, ReactNode } from 'react';

interface CensorContextType {
  censored: boolean;
  toggleCensor: () => void;
  censor: (text: string) => string;
}

const CensorContext = createContext<CensorContextType>({
  censored: false,
  toggleCensor: () => {},
  censor: (t) => t,
});

export function CensorProvider({ children }: { children: ReactNode }) {
  const [censored, setCensored] = useState(false);

  const toggleCensor = () => setCensored((prev) => !prev);

  const censor = (text: string): string => {
    if (!censored) return text;
    // Replace every word with ████ blocks of similar length
    return text.replace(/\S+/g, (word) => '█'.repeat(Math.max(3, Math.min(word.length, 8))));
  };

  return (
    <CensorContext.Provider value={{ censored, toggleCensor, censor }}>
      {children}
    </CensorContext.Provider>
  );
}

export function useCensor() {
  return useContext(CensorContext);
}
